'use strict';

module.exports = {
  '18': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 18,
    investStopAge: 60
  },
  '19': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 19,
    investStopAge: 60
  },
  '20': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 20,
    investStopAge: 60
  },
  '21': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 21,
    investStopAge: 60
  },
  '22': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 22,
    investStopAge: 60
  },
  '23': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 23,
    investStopAge: 60
  },
  '24': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 24,
    investStopAge: 60
  },
  '25': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 25,
    investStopAge: 60
  },
  '26': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 26,
    investStopAge: 60
  },
  '27': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 27,
    investStopAge: 60
  },
  '28': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 28,
    investStopAge: 60
  },
  '29': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 29,
    investStopAge: 60
  },
  '30': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 30,
    investStopAge: 60
  },
  '31': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 31,
    investStopAge: 60
  },
  '32': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 32,
    investStopAge: 60
  },
  '33': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 33,
    investStopAge: 60
  },
  '34': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 34,
    investStopAge: 60
  },
  '35': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 35,
    investStopAge: 60
  },
  '36': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 36,
    investStopAge: 60
  },
  '37': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 37,
    investStopAge: 60
  },
  '38': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 38,
    investStopAge: 60
  },
  '39': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 39,
    investStopAge: 60
  },
  '40': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 40,
    investStopAge: 60
  },
  '41': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 41,
    investStopAge: 60
  },
  '42': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 42,
    investStopAge: 60
  },
  '43': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 43,
    investStopAge: 60
  },
  '44': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 44,
    investStopAge: 60
  },
  '45': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 45,
    investStopAge: 60
  },
  '46': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 46,
    investStopAge: 60
  },
  '47': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 47,
    investStopAge: 60
  },
  '48': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 48,
    investStopAge: 60
  },
  '49': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 49,
    investStopAge: 60
  },
  '50': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 50,
    investStopAge: 60
  },
  '51': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 51,
    investStopAge: 60
  },
  '52': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 52,
    investStopAge: 60
  },
  '53': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 53,
    investStopAge: 60
  },
  '54': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 54,
    investStopAge: 60
  },
  '55': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 55,
    investStopAge: 60
  },
  '56': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 56,
    investStopAge: 60
  },
  '57': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 57,
    investStopAge: 60
  },
  '58': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 58,
    investStopAge: 60
  },
  '59': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 59,
    investStopAge: 60
  },
  '60': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 60,
    investStopAge: 65
  },
  '61': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 61,
    investStopAge: 66
  },
  '62': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 62,
    investStopAge: 67
  },
  '63': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 63,
    investStopAge: 68
  },
  '64': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 64,
    investStopAge: 69
  },
  '65': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 65,
    investStopAge: 70
  },
  '66': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 66,
    investStopAge: 71
  },
  '67': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 67,
    investStopAge: 72
  },
  '68': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 68,
    investStopAge: 73
  },
  '69': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 69,
    investStopAge: 74
  },
  '70': {
    spendStartAge: 80,
    spendStopAge: 80,
    investStartAge: 70,
    investStopAge: 75
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/config/dynamic-freedom.js
// module id = 219
// module chunks = 0